import { render } from "./LayoutPassThru.vue?vue&type=template&id=3e4e0fae&ts=true"
import script from "./LayoutPassThru.vue?vue&type=script&lang=ts"
export * from "./LayoutPassThru.vue?vue&type=script&lang=ts"

import "./LayoutPassThru.vue?vue&type=style&index=0&id=3e4e0fae&lang=scss"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__